import React from 'react'

import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'

import './App.css'

import {
  Route,
  withRouter,
  Switch,
} from 'react-router-dom'

import HomeContainer from './home'
import AdminContainer from './admin'



const colors = {
  blue: '#00a69c',
  yellow: '#fdb813',
  red: '#eb432e',
}

let theme = createMuiTheme({
  palette: {
    primary: { main: colors.red },
    secondary: { main: colors.blue },
    others: {
      white: 'white',
      gray: 'lightgray',
    },
    status: {
      error: colors.red,
      warning: colors.yellow,
    },
    influence: {
      connect: colors.blue,
      convey: colors.yellow,
      convince: colors.red,
    },
  },
  status: {
    danger: 'yellow',
  },
  typography: {
    fontFamily: [
      '"Poppins"',
      '"Roboto"',
      'sans-serif',
    ].join(',')
  },
})

theme = responsiveFontSizes(theme)

function App() {
  return (
    <div className='App'>
      <ThemeProvider theme={theme}>
        <Switch>
          <Route path='/admin' component={AdminContainer} />
          <Route path='/' component={HomeContainer} /> {/* Default case -> send home*/}
        </Switch>
      </ThemeProvider>
    </div>
  )
}

export default withRouter(App);
